import vars from '../helpers';
import JustValidate from 'just-validate';

const init = () => {
	if (!vars.html.classList.contains('page-home')) {
		return;
	}

	const helperButton = document.querySelector('.button--helper');
	const helperForm = document.querySelector('.helper__form');
	const helperSelect = document.querySelector('.helper__label select');
	const helperInput = document.querySelectorAll('.helper__input');
	const validation = new JustValidate('.helper__form', {
		errorFieldCssClass: 'is-error',
		errorLabelStyle: {
			display: 'none',
		},
	});

	helperSelect.addEventListener('change', (e) => {
		document.querySelectorAll('.helper__label.communicate').forEach((el) => {
			el.classList.add('hidden');
		});
		document.querySelectorAll('.helper__input.communicate').forEach((el) => {
			el.value = '';
		});
		helperForm.querySelector(`#${e.target.value}`).closest('.helper__label').classList.remove('hidden');
	});

	const handleFormSubmit = () => {
		const data = new FormData(helperForm);

		fetch('/contact.php', {
			method: 'POST',
			body: data,
		})
			.then((response) => {
				if (response.ok) {
					const msg = document.querySelector('.success');
					msg.classList.add('active');
					helperForm.reset();
				} else {
					const msg = document.querySelector('.unsuccess');

					msg.classList.add('active');
				}
			})
			.catch(() => {
				const msg = document.querySelector('.unsuccess');

				msg.classList.add('active');
			});
	};

	const requiredCheck = (fields) => {
		if (fields['#phone'].isValid || fields['#email'].isValid || fields['#telegram'].isValid || fields['#signal'].isValid) {
			handleFormSubmit();
		}
	};

	if (vars.html.classList.contains('page-home')) {
		validation
			.addField('#name', [
				{
					rule: 'required',
				},
			])
			.addField('#company', [
				{
					rule: 'required',
				},
			])
			.addField('#phone', [
				{
					rule: 'required',
				},
				{
					rule: 'number',
				},
			])
			.addField('#email', [
				{
					rule: 'required',
				},
				{
					rule: 'email',
				},
			])
			.addField('#telegram', [
				{
					rule: 'required',
				},
			])
			.addField('#signal', [
				{
					rule: 'required',
				},
			])
			.addField('#accept', [
				{
					rule: 'required',
				},
			])
			.onSuccess(handleFormSubmit)
			.onFail(requiredCheck);

		// helperButton.addEventListener('click', () => {

		// });
	}
};

export default {
	init,
};
